var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNovoGrupo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse-1",
    cx: 16,
    cy: 16,
    rx: 16,
    ry: 16
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 0,
    y: 0,
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#ellipse-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "rgb(52,55,54)",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 3,
    mask: "url(#mask-2)",
    xlinkHref: "#ellipse-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(52,55,54)",
    fillRule: "evenodd",
    d: "M24.00120115 14.71436728l-.00000144 2.5715332-6.7142334-.00000377-.00000377 6.71435547-2.57147217-.00000144.00000377-6.71435547-6.71429443-.00000377.00000144-2.5715332 6.71429444.00000377.00000377-6.71411133 2.57147217.00000144-.00000378 6.71411133 6.7142334.00000377z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNovoGrupo);
export default __webpack_public_path__ + "static/media/add_novo_grupo.aa6e7fde2b0622798760f39a6e9fa24e.svg";
export { ForwardRef as ReactComponent };